import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import { Stack, Button, Container, Typography, Box, Card, IconButton, Popover, MenuItem, Switch } from '@mui/material';
import Iconify from 'ui-component/iconify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddExchangeRate from './AddExchangeRate';
import EditExchangeRate from './EditExchangeRate';
import { getApi } from 'views/services/api';
import { patchApi } from 'views/services/api';
import { toast } from 'react-toastify';
import axios from 'axios'; // Asegúrate de importar axios

const ExchangeRate = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [exchangeRates, setExchangeRates] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setRowData(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchExchangeRates = async () => {
    try {
      const hotel = JSON.parse(localStorage.getItem('hotelData')) || {};
      const res = await getApi(`api/exchange/viewall/${hotel.hotelId}`);
      setExchangeRates(res.data);
    } catch (error) {
      console.error('Error fetching exchange rates:', error);
    }
  };

  useEffect(() => {
    fetchExchangeRates();
  }, [openAdd, openEdit, refresh]);

  const handleToggle = async (id, currentStatus) => {
    try {
      await patchApi(`api/exchange/toggle/${id}`, { isActive: !currentStatus });
      toast.success('Status updated');
      setRefresh(!refresh);
    } catch (error) {
      console.error('Error toggling status:', error);
      toast.error('Failed to update status');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://localhost:5001/api/exchange/delete/${id}`);
      toast.success('Exchange rate deleted successfully');
      setRefresh(!refresh); // Refresca la lista después de eliminar
    } catch (error) {
      console.error('Error deleting exchange rate:', error);
      toast.error('Failed to delete exchange rate');
    }
  };

  const columns = [
    { field: 'currency', headerName: 'Currency', flex: 1 },
    { field: 'abbreviation', headerName: 'Abbreviation', flex: 1 },
    { field: 'rate', headerName: 'Exchange Rate', flex: 1 },
    {
      field: 'isActive',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => <Switch checked={params.row.isActive} onChange={() => handleToggle(params.row._id, params.row.isActive)} />
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <div>
          <IconButton onClick={(e) => handleClick(e, params.row)}>
            <MoreVertIcon />
          </IconButton>
          <Popover open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            <MenuItem
              onClick={() => {
                setOpenEdit(true);
                handleClose();
              }}
            >
              <EditIcon sx={{ mr: 1 }} /> Edit
            </MenuItem>
            <MenuItem
              sx={{ color: 'red' }}
              onClick={() => {
                handleDelete(params.row._id); // Llama a la función de eliminación
                handleClose(); // Cierra el popover
              }}
            >
              <DeleteIcon sx={{ mr: 1 }} /> Delete
            </MenuItem>
          </Popover>
        </div>
      )
    }
  ];

  return (
    <Container>
      <Stack direction="row" justifyContent="space-between" mb={3}>
        <Typography variant="h4">Exchange Rate</Typography>
        <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setOpenAdd(true)}>
          Add Rate
        </Button>
      </Stack>
      <Card>
        <Box sx={{ height: 500 }}>
          <DataGrid rows={exchangeRates} columns={columns} getRowId={(row) => row._id} components={{ Toolbar: GridToolbar }} />
        </Box>
      </Card>

      <AddExchangeRate open={openAdd} handleClose={() => setOpenAdd(false)} onRefresh={() => setRefresh(!refresh)} />

      {rowData && (
        <EditExchangeRate
          open={openEdit}
          handleClose={() => {
            setOpenEdit(false);
            setRowData(null);
          }}
          data={rowData}
          onRefresh={() => setRefresh(!refresh)}
        />
      )}
    </Container>
  );
};

export default ExchangeRate;
